import { selectIsWhatsAppInfobipLocalesEnabled } from 'core/userContext';
import { createPositiveToastMessage } from 'modules/projectSettings/utils';
import { findCountryCode } from 'modules/templateEditor/common/LocaleLabel/LocaleLabel';
import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer';
import { useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { WarningBanner } from 'ui/banner';
import { BUTTON_SIZES, DestructiveButton } from 'ui/button';
import { FlagIcon } from 'ui/flags';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalFooter, ModalHeader } from 'ui/modal';
import { FIELD_NAMES } from '../../constants';
import {
  DeleteLocalePayload,
  ProjectSettingsFormSchemaType,
  useProjectSettingsModalsContext,
} from '../../contexts';
import { InlineFlagWrapper, StyledModalBody } from '../Styled';

const { LOCALES, MAPPED_LOCALES } = FIELD_NAMES;

export const DeleteLocaleModal = () => {
  const dispatch = useDispatch();
  const isWhatsAppInfobipLocalesEnabled = useSelector(selectIsWhatsAppInfobipLocalesEnabled);
  const { getValues, setValue } = useFormContext<ProjectSettingsFormSchemaType>();
  const { modalState, hideModal } = useProjectSettingsModalsContext();

  const locale = modalState?.payload as DeleteLocalePayload;

  const onSubmit = () => {
    try {
      const current = getValues(LOCALES) || [];
      const next = current.filter((val) => val !== locale);
      setValue(LOCALES, next, { shouldDirty: true });
      if (isWhatsAppInfobipLocalesEnabled) {
        setValue(
          MAPPED_LOCALES,
          getValues(MAPPED_LOCALES).filter((o) => o.tag !== locale),
          { shouldDirty: true },
        );
      }
      const message = createPositiveToastMessage('Locale', 'deleted');
      dispatch(addPositiveToast(message));
    } catch (e) {
      dispatch(
        addNegativeToastWithErrorId(
          'Unable to delete locale. Please try again.',
          'DeleteLocaleModal',
          e,
        ),
      );
    }
    hideModal();
  };

  return (
    <Modal
      id="add-locale-modal"
      onClose={hideModal}
      isModalOpen={true}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.DELETE}
    >
      <ModalHeader>Delete locale?</ModalHeader>
      <StyledModalBody>
        <p>
          Are you sure you want to delete locale{' '}
          <InlineFlagWrapper>
            <FlagIcon code={findCountryCode(locale)} /> <strong>{locale}</strong>
          </InlineFlagWrapper>
          ? This cannot be undone.
        </p>
        <WarningBanner>
          Any template or campaign content using this locale will no longer be available.
        </WarningBanner>
      </StyledModalBody>
      <ModalFooter onClose={hideModal}>
        <DestructiveButton onClick={onSubmit} size={BUTTON_SIZES.LARGE}>
          Delete locale
        </DestructiveButton>
      </ModalFooter>
    </Modal>
  );
};
